export const CACHE_KEY_LIST_TEMPLATES_INCIDENTS = 'templates-incidents';
export const CACHE_KEY_TEMPLATES_INCIDENTS = 'templates-incidents-one';
export const ROUTE_PATH_TEMPLATES_INCIDENTS = '/templates/list/incidents';
export const TRANSLATION_PREFIX_TEMPLATES_INCIDENTS = 'incidences';
export const INCIDENTS_DIALOG_NAME_SPACE = 'incidents-dialog';

export const ISSUE_RISK_LEVEL = {
  High: 'high',
  Medium: 'medium',
  Low: 'low',
  Infrastructure: 'infrastructure',
  IE: 'IE',
  P1: 'P1',
  Critical: 'critical',
};


